import { isCognitoEnabled } from './env';

export const LegacyCookieKeys = {
  Auth: 'authToken',
  AuthAccessToken: 'authAccessToken',
} as const;

export const CognitoCookieKeys = {
  IdToken: 'cognitoIdToken',
  AccessToken: 'cognitoAccessToken',
} as const;

export const CookieKeys = {
  /** Primary auth token: Bearer for the Ari API and source of identity claims. */
  Auth: isCognitoEnabled ? CognitoCookieKeys.IdToken : LegacyCookieKeys.Auth,
  /** Bearer for the RG API (`rgApiFetch`). Same as `Auth` in legacy mode. */
  AuthAccessToken: isCognitoEnabled
    ? CognitoCookieKeys.AccessToken
    : LegacyCookieKeys.AuthAccessToken,
  LegacyAuth: LegacyCookieKeys.Auth,
  LegacyAuthAccessToken: LegacyCookieKeys.AuthAccessToken,
  CognitoIdToken: CognitoCookieKeys.IdToken,
  CognitoAccessToken: CognitoCookieKeys.AccessToken,
  Domains: '.rentgrata.com',
  CSRF_TOKEN_HEADER: 'X-CSRF-Token',
  CSRF_SECRET: 'csrfSecret',
  ACCEPT_TERMS_OF_SERVICE: 'acceptTermsOfService',
  THEME_COOKIE_NAME: 'theme',
  SIDEBAR_STATE_COOKIE_NAME: 'sidebarState',
} as const;

export enum ErrorTypes {
  NetworkError = 'Network Error',
  ClientError = 'Client Error',
}

export enum StorageKeys {
  ActiveAnalysisEntityStorage = 'active-analysis-entity',
}

export enum UrlPaths {
  HOME = '/',
  SIGN_IN = '/sign-in',
  TERMS_OF_USE = '/onboarding/terms-of-use',
}

/**
 * @description: The maximum age of a token in seconds.
 */
export enum TokenMaxAge {
  EIGHT_HOURS = 8 * 60 * 60,
  ZERO = 0,
}


export enum KeyboardKey {
  ENTER = 'Enter',
  SPACE = ' ',
}
